// What an agent's command looks like at home, as actions (P36): one table from
// the command (acts.ts reads it into an Act) to a few actions in a row, each for
// so long. The HUD's words stay acts.ts's; this is only what the body does.
import type { Act } from '../acts.js';

export type Seq = [string, number][];
const loops = (a: string, period: number, n: number): [string, number] => [a, period * n];

// command (its first word, or a Lisp form's head) → actions
export function workFor(act: Act, command: string): Seq | null {
  const c = command.trim().toLowerCase(), w = c.replace(/^\(\s*/, '').split(/[\s()]+/)[0] || '', words = act.words || '';
  if (act.kind === 'refused') return null;
  if (/^\(\s*(defobject|defthing|deflamp)/.test(c) || (act.kind === 'lisp' && /object|program/.test(words))) return [loops('script', 2.0, 3)];
  switch (w) {
    case 'cook': return /thinking/.test(words) ? null : [loops('chop', 0.8, 4), loops('stir', 1.6, 3), loops('taste', 2.4, 1)];
    case 'bake': return [loops('stir', 1.6, 2), loops('pie', 3.0, 1)];
    case 'serve': case 'host': return [loops('pie', 3.0, 1)];
    case 'craft': case 'make': return /bed/.test(c) ? null : [loops('hammer', 0.9, 4), loops('saw', 1.0, 3), loops('sew', 1.5, 2), loops('tada', 2.4, 1)];
    case 'gather': case 'forage': return /round the garden|basket/.test(words) ? [loops('pick', 2.2, 3)] : null;
    case 'postcard': case 'note': case 'describe': case 'letter': return [loops('write', 3.4, 2)];
    case 'sign': return [loops('sign', 2.8, 2)];
    case 'gazette': return [loops('gazette', 4.0, 2)];
    case 'read': return /gazette|paper/.test(c) ? [loops('gazette', 4.0, 2)] : [loops('read', 3.0, 2)];
    case 'journal': case 'guestbook': return [loops('read', 3.0, 2)];
    case 'invite': return [loops('ticket', 2.2, 2)];
    case 'paint': return [loops('paint', 1.2, 4)];
    case 'window-box': case 'plant': case 'sow': return [loops('plant', 3.4, 2)];
    case 'compost': return [loops('compost', 2.6, 2)];
    case 'water': return [loops('water', 1.8, 3)];
  }
  if (/compost/.test(c)) return [loops('compost', 2.6, 2)];
  return null;
}
